module.exports = __webpack_public_path__ + "static/leslie-group-logo-b93f8e9ca58fa5fbd7456d257c963ed4.jpg";